import { GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { Dispatch, SetStateAction } from 'react';
import { DataResult, State, process } from '@progress/kendo-data-query';

interface UseFrontendKendoGridDataHandlerProps {
    setGridState: Dispatch<SetStateAction<State>>;
    changeGridResult: (result: any[] | DataResult, runTransform?: boolean) => void;
    data: any[];
}

const useFrontendKendoGridDataHandler = ({
    setGridState,
    changeGridResult,
    data,
}: UseFrontendKendoGridDataHandlerProps) => {
    const handleDataStateChange = (e: GridDataStateChangeEvent) => {
        e.syntheticEvent?.stopPropagation();
        setGridState(e.dataState);
        if (data) {
            changeGridResult(process(data, e.dataState));
        }
    };

    return handleDataStateChange;
};

export default useFrontendKendoGridDataHandler;
